import type { ReactNode } from "react";

interface QueryStateProps {
  isLoading: boolean;
  error: unknown;
  empty?: boolean;
  emptyMessage?: string;
  children: ReactNode;
}

export function QueryState({ isLoading, error, empty, emptyMessage, children }: QueryStateProps) {
  if (isLoading) {
    return <p className="text-[color:var(--color-alto-muted)] py-4">Chargement…</p>;
  }
  if (error) {
    return (
      <p className="text-[color:var(--color-alto-accent)] py-4">
        Impossible de charger : {(error as Error).message}
      </p>
    );
  }
  if (empty) {
    return (
      <p className="text-[color:var(--color-alto-muted)] py-4">
        {emptyMessage ?? "Aucun élément à afficher."}
      </p>
    );
  }
  return <>{children}</>;
}
